import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { ref } from "vue";
import { CaseApi } from "@/services/Api";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBlockWrapper',
  props: {
  totalHits: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const resetFilters = () => {
  activeFilters.value = {};
  updateCases();
};
const isOpen = ref<boolean>(false);
const hideInitial = ref<boolean>(false);
const open = () => {
  isOpen.value = true;
};
const close = () => {
  isOpen.value = false;
};
const toggleOpen = () => {
  if (isOpen.value) {
    close();
  } else {
    open();
  }
};
const onFilterClick = () => {
  toggleOpen();
};
const activeFilters = ref({});
const setActiveFilter = (filterGroupKey: string, id: string) => {
  const group = getFilterCategory(filterGroupKey);
  if (group) {
    const val = activeFilters.value[filterGroupKey].find((x) => x == id);
    if (!val) {
      activeFilters.value[filterGroupKey].push(id);
    }
  }
};
const setUnactiveFilter = (filterGroupKey: string, id: string) => {
  const group = getFilterCategory(filterGroupKey);
  if (group) {
    const val = activeFilters.value[filterGroupKey].find((x) => x == id);
    if (val) {
      activeFilters.value[filterGroupKey] = activeFilters.value[filterGroupKey].filter((x) => x != id);
    }
  }
};
const toggleFilter = (filterGroupKey: string, id: string) => {
  const group = getFilterCategory(filterGroupKey);
  if (group) {
    const val = activeFilters.value[filterGroupKey].find((x) => x == id);
    if (val) {
      setUnactiveFilter(filterGroupKey, id);
    } else {
      setActiveFilter(filterGroupKey, id);
    }
  }
};
const onToggleFilterClick = (filterGroupKey: string, id: string) => {
  toggleFilter(filterGroupKey, id);
  updateCases();
};
const getFilterCategory = (categoryId: string) => {
  let category = activeFilters.value[categoryId];
  if (!category) {
    category = [];
    activeFilters.value[categoryId] = category;
  }
  return category;
};
const result = ref<any>();
const totalHits = ref<number>(props.totalHits);
const updateCases = async () => {
  const response = await CaseApi.searchCases({ ...activeFilters.value });
  updateFilters(response?.facets);
  result.value = response.casePages;
  totalHits.value = response.totalHits;
  hideInitial.value = true;
};

const updateFilters = (facets: Array<any>) => {
  const groups = document.querySelectorAll(".filter-group");
  for (const group of groups) {
    let facetGroup = facets?.find((x) => x.key == group.id);
    if (!facetGroup) {
      facetGroup = facets?.find((x) => `${x.key}-2` == group.id);
    }
    const filters = [...group.querySelectorAll(".filter-option")];
    for (const filter of filters) {
      const filterId = filter.id.replace(`${group.id}-`, "").replace("2-", "");
      const facetValue = facetGroup?.available.find((x) => x.value == filterId);
      if (facetValue) {
        filter.classList.remove("d-none");
        const filterValueEl = filter.querySelector(".filterValue");
        if (filterValueEl) {
          filterValueEl.textContent = `${facetValue.value} (${facetValue.hits})`;
        }
      } else {
        filter.classList.add("d-none");
      }
    }
  }
};

const filtersModalAccordionId = ref<string>();
const onToggleFilterAccordion = (id: string) => {
  if (filtersModalAccordionId.value == id) {
    filtersModalAccordionId.value = undefined;
  } else {
    filtersModalAccordionId.value = id;
  }
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    activeFilters: activeFilters.value,
    isOpen: isOpen.value,
    onFilterClick: onFilterClick,
    onToggleFilterClick: onToggleFilterClick,
    result: result.value,
    hideInitial: hideInitial.value,
    filtersModalAccordionId: filtersModalAccordionId.value,
    onToggleFilterAccordion: onToggleFilterAccordion,
    closeFilters: close,
    resetFilters: resetFilters,
    totalHits: totalHits.value
  })
}
}

})